import React, {FC, useContext} from 'react';
import {AsyncIdFilterInput} from "./AsyncIdFilterInput";
import {LanguageContext} from "../../../config/ContextConfig";
import {ProjectStageFilterInputProps} from "./ProjectStageFilterInput";
import {projectPhaseSelectRoute} from "../../../models/projects/ProjectStagePhase";
import {projectStagePhaseFilterName} from "../../../models/common/DataFilter";

export interface ProjectStagePhaseFilterInputProps extends ProjectStageFilterInputProps {
    projectStageId: number
}

// re-exported for the existing importers: the canonical home of the filter
// names is the model layer ( see DataFilter )
export {projectStagePhaseFilterName};

/**
 * ProjectStagePhaseFilterInput is a wrapper component around AsyncIdFilterInput
 *
 * it providers a select input to choose the project you want in the dataset from the API backend
 *
 * @see AsyncIdFilterInput
 *
 *
 * @constructor
 */
export function ProjectStagePhaseFilterInput( props: ProjectStagePhaseFilterInputProps ) {
    const language = useContext( LanguageContext );

    return (
        <AsyncIdFilterInput
            {...props}
            title={language.projects.rowProjectStagePhase}
            route={ projectPhaseSelectRoute( props.projectId, props.projectStageId )}
            filterName={props.filterName ?? projectStagePhaseFilterName }
        />
    );
}